/**
 * POPULATIONS
 * List of populations
 */
import { useAppSelector } from "@/core/root-reducer"
import populationStore from "../model/population.store"
import PopulationCard from "./PopulationCard"

export default function Populations() {
  const populations = useAppSelector(populationStore.selectors.listFiltered)

  return (
    <div className="flex flex-wrap">
      {populations.map((population) => (
        <PopulationCard key={population.id} population={population} />
      ))}
    </div>
  )
}
